import React, {
  useState,
  useCallback,
  Fragment,
  useEffect,
  useMemo,
} from 'react';
import { Box, Collapse, Stack, Divider } from '@mui/material';
import { useSelector } from 'react-redux';
import FilterView from '../../views/Filter.view';
import SearchView from '../../views/Search.view';
import AddButton from './components/Add.component';
import FilterButton from './components/Filter.component';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { getItem } from '../../utility/Storage.utility';
import ActionsButton from './components/Actions.component';
import ActionTemplate from '../../pages/templates/Action.template';

const ToolbarComponent = ({
  tag,
  search,
  add,
  filter,
  children,
  link,
  tagPermissions,
  list,
  action,
  query,
}) => {
  const navigate = useNavigate();
  const filters = useSelector((state) => state[tag].filter.value);
  const [showFilter, setShowFilter] = useState(false);
  const [showAction, setShowAction] = useState(false);

  const userAuth = useSelector((state) => state.login?.user);
  const {
    list: { selected },
  } = useSelector((state) => state[tag]);
  const numSelected = useMemo(
    () => selected && Object.values(selected).flat()?.length,
    [selected]
  );

  const permissions = useMemo(
    () =>
      tagPermissions
        ? userAuth.permissions[_.toUpper(tagPermissions)]
        : userAuth.permissions[_.toUpper(tag)],
    [tagPermissions, tag, userAuth]
  );
  const defaultFilters = useMemo(
    () => _.omit(getItem(tag)?.filters, ['season', 'season_to', 'seasonTo']) || filters,
    [tag, filters]
  );

  const onClickFilter = useCallback(() => {
    setShowFilter(!showFilter);
    setShowAction(false);
  }, [showFilter, setShowFilter]);

  const onClickAction = useCallback(() => {
    setShowAction(!showAction);
    setShowFilter(false);
  }, [showAction, setShowAction]);

  const onClickAdd = useCallback(
    (to, target) => (e) => {
      if (target === '_blank') {
        window.open(to, target);
      } else {
        navigate(to, { state: { from: tag } });
      }
    },
    [navigate, tag]
  );

  useEffect(() => {
    setShowFilter(false);
  }, [tag]);

  return (
    <Fragment>
      <Box
        sx={{ padding: 2 }}
        display={{ sm: 'flex' }}
        justifyContent={'space-between'}
      >
        {search && <SearchView search={search} tag={tag} list={list} />}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2 }}
        >
          {permissions?.UPDATE === 'true' &&
            !!action?.conf &&
            !!numSelected &&
            numSelected > 0 && (
              <ActionsButton showAction={showAction} onClick={onClickAction} />
            )}
          {link && permissions?.LINK === 'true' && (
            <AddButton
              onClick={onClickAdd(link.to, link.target || '_self')}
              label={link?.label}
            />
          )}

          {add && permissions?.CREATE === 'true' && (
            <AddButton
              onClick={onClickAdd(add.to, add.target || '_self')}
              label={add?.label}
            />
          )}
          {filter && (
            <FilterButton
              filters={defaultFilters}
              showFilter={showFilter}
              onClick={onClickFilter}
            />
          )}
        </Stack>
      </Box>
      <Divider />
      {filter && (
        <Collapse in={showFilter}>
          <Box sx={{ padding: 2 }}>
            <FilterView tag={tag} filter={filter} list={list}>
              {children}
            </FilterView>
          </Box>
          <Divider />
        </Collapse>
      )}

      {permissions?.UPDATE === 'true' && !!action?.conf && !!numSelected && numSelected > 0 && (
        <Collapse in={showAction}>
          <Box sx={{ padding: 2 }}>
            <ActionTemplate
              tag={tag}
              action={action}
              list={list}
              query={query}
            />
          </Box>
        </Collapse>
      )}
    </Fragment>
  );
};

export default ToolbarComponent;
